import { PER_CHUNK } from '../../../constants';
export function splitInChunks(
  chunkSize = PER_CHUNK
): (previousValue: any, currentValue: any, currentIndex: number, array: any) => any {
  return (resultArray: any, item: any, index: number) => {
    const chunkIndex = Math.floor(index / chunkSize);
    if (!resultArray[chunkIndex]) {
      resultArray[chunkIndex] = []; // start a new chunk
    }
    resultArray[chunkIndex].push(item);
    return resultArray;
  };
}
